<template>
    <div v-if="!expired && asTooltip" class="d-inline">
        <i class="fa fa-info-circle" aria-hidden="true" v-b-tooltip.hover="$t('tcat_size_hint')"></i>
    </div>
    <div v-else-if="!expired" v-html="text"></div>
</template>

<script>
import moment from 'moment';
import { getExchangedAmount } from '../../bu/CurrencyUtils';
import { mapGetters } from 'vuex';

export default {
    props: {
        item: { type: Object, required: true },
        spec: { type: Object, required: false },
        pricingRule: { type: Object, required: true },
        asTooltip: { type: Boolean, default: false },
        provider: { type: Object, required: true },
    },
    computed: {
        ...mapGetters({
            currency: 'currencies/currency',
            currencyRateMap: 'currencies/currencyRateMap',
            currencyOptions: 'currencies/currencyOptions',
        }),
        expired() {
            if (this.pricingRule.period_end) {
                return moment(this.pricingRule.period_end).isBefore(moment());
            }
            return false;
        },
        text() {
            var result = "";
            if (this.pricingRule.weekdays) {
                result += this.pricingRule.weekdays.split(',').map((weekday) => this.$t(`message.weekday_${weekday}`)).join(this.$t('separator')) + " ";
            }
            if (this.pricingRule.period_start && this.pricingRule.period_end) {
                const isSameYear = this.pricingRule.period_start.substring(0, 4) === this.pricingRule.period_end.substring(0, 4);
                result += `${this.formatDateString(this.pricingRule.period_start)}-${this.formatDateString(this.pricingRule.period_end, !isSameYear)} `;
            }
            const target = this.spec || this.item;

            if (target.is_renting) {
                result += this.$t(`price_per_${target.renting_charge_type.toLowerCase()}`, {
                    price: this.getExchangedAmount(this.pricingRule.price)
                });
            } else {
                result += this.getExchangedAmount(this.pricingRule.price);
            }
            return result;
        }
    },
    methods: {
        formatDateString(dateString, withYear = true) {
            const format = withYear ? 'YYYY-MM-DD' : 'MM-DD';
            return `${moment(dateString).tz('Asia/Taipei').format(format)}`;
        },
        getExchangedAmount(amount) {
            return getExchangedAmount({
                rateMap: this.currencyRateMap,
                amount,
                from: this.provider.currency || 'TWD',
                to: this.currency,
                currencyOptions: this.currencyOptions,
            });
        },
    }
}
</script>

<i18n>
{
    "zh": {
        "separator": "、",
        "price_per_day": "{price}/天",
        "price_per_booking": "{price}/次",
        "price_per_night": "{price}/晚",
        "price_per_hour": "{price}/小時"
    },
    "en": {
        "separator": ", ",
        "price_per_day": "{price}/day",
        "price_per_booking": "{price}/booking",
        "price_per_night": "{price}/night",
        "price_per_hour": "{price}/hour"
    }
}
</i18n>